import {$dom} from '../../../../helpers/dom';
import vars from './vars';
import {isElement, sleep} from '../../../../helpers/_utilities';
import gsap from 'gsap';
import variables from '../../../../variables';
import {$events} from '../../../../helpers/events';

const {delegate} = $events;

const {
	get,
	addClass,
	removeClass,
	hasClass,
	html,
	exist
} = $dom;

const {
	asideSelector,
	asideHiddenContentSelector,
	asideHiddenToggleButtonSelector,
	scrollbarNeedUpdateEventName
} = vars;


export default function catalogAsideToggleHidden() {

	const
		{active} = variables.classNames
	;

	let aside, hiddenHeight, hiddenPart;

	gsap.defaults({duration: variables.gsapDefaultDuration});

	function slideUp() {
		gsap.to(hiddenPart, {
			height: `-=${hiddenHeight}`,
			maxHeight: `-=${hiddenHeight}`,
			duration: variables.gsapDefaultDuration,
			onStart() {
				removeClass(hiddenPart, active);
			},
			onComplete() {
				$events.emit(scrollbarNeedUpdateEventName, document, {direction: 'up'})
			}
		});
	}

	function slideDown() {
		gsap.to(hiddenPart, {
			height: `+=${hiddenHeight}`,
			maxHeight: `+=${hiddenHeight}`,
			duration: variables.gsapDefaultDuration,
			onStart() {
				addClass(hiddenPart, active);
			},
			onComplete() {
				$events.emit(scrollbarNeedUpdateEventName, document, {direction: 'down'})
			}
		});
	}

	function setButtonContent(btn, state) {
		let tagName = btn.tagName.toLowerCase();

		if (tagName !== 'button' && tagName !== 'a') return;

		switch (state) {
			case 'collapsed':
				html(get('span', btn), btn.dataset.collapsedText || '');
				break;

			case 'expanded':
				html(get('span', btn), btn.dataset.expandedText || '');
				break;
		}
	}

	function toggle() {
		if (hasClass(hiddenPart, active)) {
			slideUp();
			removeClass(hiddenPart, active);
			setButtonContent(this, 'collapsed');
		} else {
			slideDown();
			addClass(hiddenPart, active);
			setButtonContent(this, 'expanded')
		}
	}

	const
		init = () => {
			if (exist(asideHiddenContentSelector)) {
				aside = get(asideSelector);
				hiddenPart = get(asideHiddenContentSelector);

				const {getProperty} = gsap;

				hiddenHeight = Array.from(hiddenPart.childNodes).reduce((prev, current) => {
					if (isElement(current)) {
						let cmnSpace = current.offsetHeight + getProperty(current, 'marginTop') + getProperty(current, 'marginBottom');
						return prev + cmnSpace
					}
					return prev
				}, 0);

				delegate
					.on('click tap', asideHiddenToggleButtonSelector, toggle)
				;
			}

		},
		destroy = () => {
			delegate
				.off('click tap', asideHiddenToggleButtonSelector, toggle)
			;
		}
	;

	return {init, destroy}

}
